import React from 'react';
import { Shield, AlertTriangle } from 'lucide-react';

/**
 * Компонент для параметров резерва на непредвиденные расходы
 */
const ContingencySection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <Shield className="w-5 h-5 mr-2 text-orange-500" />
          Резерв на непредвиденные расходы
        </h3>
        <label className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="includeContingency"
            checked={formData.includeContingency}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2">Включить в расчет</span>
        </label>
      </div>
      
      {formData.includeContingency && (
        <div>
          <div className="flex items-center">
            <label htmlFor="contingencyPercentage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mr-3">
              Процент от общей стоимости:
            </label>
            <div className="relative flex items-center w-40">
              <input
                type="text"
                id="contingencyPercentage"
                name="contingencyPercentage"
                value={formData.contingencyPercentage}
                onChange={handleInputChange}
                className={`form-input w-full pr-8 ${errors.contingencyPercentage ? 'input-error' : ''}`}
                placeholder="15"
              />
              <span className="absolute right-3 text-gray-500 dark:text-gray-400">%</span>
            </div>
          </div>
          {errors.contingencyPercentage && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.contingencyPercentage}
            </p>
          )}
        </div>
      )}

      {/* Информация о важности резерва */}
      <div className="mt-4 flex items-start bg-orange-100 dark:bg-orange-900/30 p-3 rounded-lg border border-orange-200 dark:border-orange-800">
        <AlertTriangle className="w-5 h-5 text-orange-600 dark:text-orange-400 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-orange-700 dark:text-orange-300 mb-1">
            Важность резерва на непредвиденные расходы
          </h4>
          <p className="text-xs text-orange-600 dark:text-orange-400">
            Проекты трансформации бизнес-процессов часто сталкиваются с непредвиденными сложностями и дополнительными расходами. 
            Рекомендуемый размер резерва зависит от сложности проекта и опыта организации:
          </p>
          <ul className="mt-1 text-xs text-orange-600 dark:text-orange-400 list-disc list-inside">
            <li>Для типовых проектов: 10-15%</li>
            <li>Для проектов средней сложности: 15-20%</li>
            <li>Для высокорисковых проектов: 20-30%</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContingencySection;